import Text from '@components/Text/Text';
import { useIntl } from 'react-intl';
import { StyledList } from './PasswordRequirements.styles';

interface PasswordRequirementsProps {
  errors?: string[];
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  errors,
}) => {
  const intl = useIntl();

  if (!errors || !errors.length) return null;

  return (
    <Text variant='h6' fontWeight='fontWeightSemiBold' marginTop={2}>
      {intl.formatMessage({
        id: 'signUp.errors.password.validationError',
      })}
      <StyledList>
        {errors.map((err) => (
          <li key={err}>
            {intl.formatMessage({
              id: `signUp.errors.password.${err}`,
            })}
          </li>
        ))}
      </StyledList>
    </Text>
  );
};

export default PasswordRequirements;
